export enum ChatRoomState {
  private,
  privateAllowInvites,
  publicWithRequest,
  public
}
